// Shared modal styling for the Admission module.
// Matches the gradient-header look used by Finance / Expense modals
// (linear-gradient 135deg, #6366f1 → #8b5cf6).

export const ADM_MODAL_HEADER = {
  background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
  border: "none",
  padding: "18px 24px",
  color: "#fff",
};

export const ADM_MODAL_TITLE = {
  color: "#fff",
  fontWeight: 700,
  fontSize: 16,
  margin: 0,
  display: "flex",
  alignItems: "center",
  gap: 10,
};

export const ADM_MODAL_TITLE_SUB = {
  display: "block",
  color: "rgba(255,255,255,0.78)",
  fontSize: 12,
  fontWeight: 500,
  marginTop: 4,
};

export const ADM_MODAL_BODY = {
  padding: "20px 24px",
  background: "#f8fafc",
};

// Use when the body hosts a full sub-component that already has its own padding
// (e.g. CreateAdmissionFormPage, FillAdmissionFormPage, AdmissionFormBuilder).
export const ADM_MODAL_BODY_FLUSH = {
  padding: 0,
  background: "#f8fafc",
  maxHeight: "calc(100vh - 160px)",
  overflowY: "auto",
};

export const ADM_MODAL_FOOTER = {
  background: "#fff",
  borderTop: "1px solid #f3f4f6",
  padding: "14px 24px",
};

// Small white circle used as a leading bullet inside the gradient header
// (matches the FeeModal pattern).
export const ADM_MODAL_HEADER_DOT = {
  width: 7,
  height: 7,
  borderRadius: "50%",
  background: "rgba(255,255,255,0.65)",
  flexShrink: 0,
};
